import React from "react";
import XenoChatBotUtil from "./xeno/xenoUtil";
import { ChatBotArgsType } from "./type";
import ChatBotVendorType from "../../enums/ChatBotVendorType";
import { modifyTopNoteStyleForChatBot } from "./util";

export default function useChatBotService(props: ChatBotArgsType) {
  const isChatBotEnabled = React.useMemo(() => Boolean(props.botApiKey), [props.botApiKey]);

  const chatBotUtil = React.useMemo(() => {
    switch (props.chatBotVendorType) {
      case ChatBotVendorType.XENO:
        return XenoChatBotUtil;
    }
  }, [props.chatBotVendorType]);

  const onChatBotLoad = React.useCallback(() => {
    modifyTopNoteStyleForChatBot();
  }, []);

  const initializeChatBot = React.useCallback(() => {
    if (!isChatBotEnabled) {
      return;
    }
    chatBotUtil?.initialize({
      userId: props.userId || "",
      userName: props.userName,
      botApiKey: props.botApiKey,
      onInit: onChatBotLoad
    });
  }, [props.userId, props.userName, props.botApiKey, isChatBotEnabled, chatBotUtil, onChatBotLoad]);

  const unInitializeBot = React.useCallback(() => {
    chatBotUtil?.destroy();
  }, [chatBotUtil]);

  return {
    unInitializeBot,
    initializeChatBot
  };
}
